// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'
import App from './App'
import router from './router'
import i18n from './i18n'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import dataV from '@jiaminghi/data-view'
// import Vant from 'vant';
// import 'vant/lib/index.css'
import jQuery from 'jquery'
import $ from 'jquery'
import './utils/jquery.table2excel' // global table2excel
import Vuex from 'vuex'
import store from './store/store'
import permission from './permission'
import components from '@/plugins/components.js';
import api from '@/api/index.js'
import echarts from 'echarts'
import 'babel-polyfill'
// import 'vue-pdf/dist/vue-pdf.css'
// import pdf from 'vue-pdf'
// import moreTreeTable from "more-tree-table"
// import 'amfe-flexible/index'
import toExcel from '@/excel/json2excel'
import _2Excel from '@/excel/2excel'
import Switch from 'iview/src/components/Switch';
import '@/assets/icon/iconfont.css'
import '@/assets/icon/iconfont.js'
import '@/assets/icon1/iconfont.css'
import '@/assets/icon1/iconfont.js'
import '@/assets/icon6/iconfont.css'
import '@/assets/icon6/iconfont.js'
import VueCookies from "vue-cookies";
import Vant from 'vant';
import 'vant/lib/index.css';

// import "lib-flexible"
// import './assets/scss/style.scss';

// import './plugins/lament_grey.js'
// import 'iview/dist/styles/iview.css';
require('es6-promise').polyfill();
// require('es6-promise/auto');

Vue.prototype.$_2Excel = _2Excel
Vue.prototype.$toExcel = toExcel
Vue.prototype.$api = api
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
Vue.use(Vuex)
Vue.use(ElementUI);
Vue.use(components);
Vue.use(dataV)
Vue.use(Switch);
Vue.use(Vant);
Vue.use(VueCookies);

// Vue.use(pdf);
// Vue.use(moreTreeTable);
// Vue.use(Vant);

/* eslint-disable no-new */
var vm = new Vue({
  el: '#app',
  router,
  store,
  i18n,
  comments: true,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js